import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { memo } from "react";

function KsbAppBar({ children }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        px: { xs: 0.25, sm: 1 },
        py: { xs: 1, sm: 1.5 }, // ✅ less height
        backgroundColor: theme.palette.background.default,
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      }}
    >
      {children}
    </Box>
  );
}
export default memo(KsbAppBar);
